import React, {Component} from 'react'
import {
    Header_Carousel_Control_Next_Icon,
    Header_Carousel_Control_Prev_Icon,
    UserImg
} from "../Icon";
import {Menu} from "./menu";
import carousel from "./../../../resources/images/carousel.png"
import televizion from "./../../../resources/images/televizion.png"
import {Sale} from "./Sale";
import { Footer } from '../Body/footer';
import Slider from "react-slick";
import alibaba from "../../../resources/images/alibaba.png";



class Header extends Component {
    render() {

            let settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1
            };

        return (
            <div className="header">
                <Menu
                    UserImg={<UserImg/>}
                />
                <div className="header-brands__brandName carousel slide carousel-inner" id="myCarousel" data-ride="carousel">
                    <Slider {...settings}>
                        <div className="carousel-item">
                            <div className="text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="item">
                                    <img src="https://mainstreet-store.com/wp-content/uploads/2019/08/Online-Shopping03.jpg" alt="" className="header-menu_carousel_img" />
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="item">
                                    <img src="https://previews.123rf.com/images/liaarevadze/liaarevadze1707/liaarevadze170700061/82024571-online-shop-banner-design-for-promotion-with-shop-front-and-shopping-icons-flat-design-vector-illust.jpg" alt="" className="header-menu_carousel_img" />
                                </div>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <div className="text-center owl-carousel owl-theme" id="owl-demo">
                                <div className="item">
                                    <img src="https://image.freepik.com/free-vector/online-shopping-infographics-leaflet_1284-14882.jpg" alt="" className="header-menu_carousel_img" />
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        );
    }
}

export default Header;
